{
  "version": 1,
  "sections": [
    { "id": "trending",   "key": "trending",   "title_ar": "الأكثر رواجاً",     "title_en": "Trending Now",   "limit": 12 },
    { "id": "latest_movies", "key": "latest_movies", "title_ar": "أحدث الأفلام",   "title_en": "Latest Movies",  "limit": 12 },
    { "id": "latest_series", "key": "latest_series", "title_ar": "أحدث المسلسلات", "title_en": "Latest Series",  "limit": 12 },
    { "id": "top_rated",  "key": "top_rated",  "title_ar": "الأعلى تقييماً",    "title_en": "Top Rated",      "limit": 12 },
    { "id": "recommended","key": "recommended","title_ar": "موصى به لك",         "title_en": "Recommended",    "limit": 12 }
  ]
}
